import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { CreditAgreementsViewTemplate } from '../CreditAgreementsViewTemplate';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { ClientCreditAgreementWip } from '~/packages/creditAgreements/ui/creditAgreementWip/ClientCreditAgreementWip';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
  creditFacilityId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const params = useParams();
  const { implementationId, creditFacilityId } = RouteParamsStruct.parse(
    params,
  );

  return (
    <ClientCreditAgreementWip
      organizationId={user.organization.id}
      implementationId={implementationId}
      creditFacilityId={creditFacilityId}
      onDonePath={`/implementations/${implementationId}/credit-facilities/${creditFacilityId}/credit-agreements`}
    />
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <CreditAgreementsViewTemplate>
          <RouteBase />
        </CreditAgreementsViewTemplate>
      </Flex>
    </RouteErrorBoundary>
  );
};
